import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);
const KEY = "ma_lang";

// Spanish translations keyed by the English source string.
// English is the default; any missing key falls back to the English source.
const ES = {
  // Navbar
  "Complimentary shipping & returns · Book a private appointment": "Envío y devoluciones gratis · Reserve una cita privada",
  "Search": "Buscar",
  "Home": "Inicio",
  "Rings": "Anillos",
  "Necklaces": "Collares",
  "Earrings": "Aretes",
  "Bracelets": "Pulseras",
  "Watches": "Relojes",
  "Collections": "Colecciones",
  "About": "Nosotros",
  "Contact": "Contacto",
  "Men": "Hombre",
  "Women": "Mujer",
  "Chains": "Cadenas",
  "Accessories": "Accesorios",
  "Blog": "Blog",
  "FAQs": "FAQs",
  "Gender": "Género",
  "Unisex": "Unisex",
  "Reviews": "Reseñas",
  "Share your experience": "Comparte tu experiencia",
  "Purchased with us? We'd love to hear your story. Leave a review and help others discover M&A Jewelry.": "¿Compraste con nosotros? Nos encantaría conocer tu experiencia. Deja tu reseña y ayuda a otros a descubrir M&A Jewelry.",
  "Leave a Review": "Deja tu Reseña",
  "See more": "Ver más",
  "Your Review": "Tu Reseña",
  "Your Rating": "Tu Calificación",
  "Your Name": "Tu Nombre",
  "Location (optional)": "Ubicación (opcional)",
  "Title (optional)": "Título (opcional)",
  "Your Message": "Tu Mensaje",
  "Submit Review": "Enviar Reseña",
  "Thank you! Your review has been submitted.": "¡Gracias! Tu reseña ha sido enviada.",
  "Thank you! Your review will be published once approved.": "¡Gracias! Tu reseña se publicará una vez sea aprobada.",
  "What our clients say": "Lo que dicen nuestros clientes",
  "Be the first to leave a review.": "Sé el primero en dejar una reseña.",
  "Please select a rating": "Por favor selecciona una calificación",
  "My Account": "Mi Cuenta",
  "Orders": "Pedidos",
  "Admin Dashboard": "Panel de Administración",
  "Sign Out": "Cerrar Sesión",
  "Sign In": "Iniciar Sesión",
  "Create Account": "Crear Cuenta",
  "Search for rings, necklaces, watches…": "Busque anillos, collares, relojes…",
  "Language": "Idioma",
  "Menu": "Menú",
  "Cart": "Carrito",
  "Dark Mode": "Modo Oscuro",
  "Light Mode": "Modo Claro",

  // Footer
  "Maison de haute joaillerie. Each piece is conceived in Chicago and crafted by hand for a lifetime of brilliance.": "Maison de alta joyería. Cada pieza se concibe en Chicago y se elabora a mano para brillar toda la vida.",
  "Shop": "Tienda",
  "Maison": "Maison",
  "The M&A Letter": "La Carta M&A",
  "Private previews, new arrivals and appointments.": "Adelantos privados, novedades y citas.",
  "Email address": "Correo electrónico",
  "Our Story": "Nuestra Historia",
  "Contact & Concierge": "Contacto y Concierge",
  "All Jewelry": "Toda la Joyería",
  "Privacy": "Privacidad",
  "Terms": "Términos",
  "Shipping & Returns": "Envíos y Devoluciones",
  "All rights reserved.": "Todos los derechos reservados.",

  // Home
  "The Winter Collection · 2026": "La Colección de Invierno · 2026",
  "Brilliance, worn": "Brillo, para",
  "for a lifetime.": "toda la vida.",
  "Hand-crafted fine jewelry, conceived in Chicago. Diamonds, gold and rare stones set to catch the light for generations.": "Alta joyería hecha a mano, concebida en Chicago. Diamantes, oro y piedras raras dispuestos para capturar la luz por generaciones.",
  "Shop the Collection": "Ver la Colección",
  "Explore Rings": "Explorar Anillos",
  "Complimentary Shipping": "Envío Gratuito",
  "On every order, worldwide": "En cada pedido, a todo el mundo",
  "Lifetime Warranty": "Garantía de por Vida",
  "Craftsmanship guaranteed": "Artesanía garantizada",
  "Ethically Sourced": "Origen Ético",
  "Conflict-free diamonds": "Diamantes libres de conflicto",
  "Free Engraving": "Grabado Gratis",
  "Make it yours": "Hazlo tuyo",
  "Explore": "Explorar",
  "Shop by Category": "Comprar por Categoría",
  "View all": "Ver todo",
  "pieces": "piezas",
  "piece": "pieza",
  "Most Coveted": "Lo Más Codiciado",
  "Best Sellers": "Más Vendidos",
  "Shop best sellers": "Ver más vendidos",
  "The Maison": "La Maison",
  "A century of quiet brilliance": "Un siglo de brillo silencioso",
  "For over a century, M&A Jewelry has crafted jewelry that transcends trends. Every stone is hand-selected, every setting sculpted by master artisans. We believe true luxury is felt — in the weight of gold, the fire of a diamond, the story a piece carries.": "M&A Jewelry ha creado joyas que trascienden las tendencias. Cada piedra se selecciona a mano, cada engaste es esculpido por maestros artesanos. Creemos que el verdadero lujo se siente — en el peso del oro, el fuego de un diamante, la historia que lleva una pieza.",
  "From the solitaire that marks a promise to the watch passed between generations, our pieces are made to be lived in and loved.": "Desde el solitario que marca una promesa hasta el reloj que pasa de generación en generación, nuestras piezas están hechas para vivirse y amarse.",
  "Discover Our Story": "Descubre Nuestra Historia",
  "Maison founded in Chicago": "Maison fundada en Chicago",
  "Just Landed": "Recién Llegado",
  "New Arrivals": "Novedades",
  "Shop new in": "Ver novedades",
  "Client Voices": "Voces de Clientes",
  "Loved by connoisseurs": "Amado por conocedores",
  "Follow the sparkle": "Sigue el brillo",

  // Catalog
  "Fine Jewelry": "Alta Joyería",
  "Category": "Categoría",
  "Collection": "Colección",
  "All Collections": "Todas las Colecciones",
  "Price": "Precio",
  "Material": "Material",
  "Finish": "Acabado",
  "Offers": "Ofertas",
  "On Sale": "En Oferta",
  "Gold Type": "Tipo de Oro",
  "18k Gold": "Oro 18k",
  "14k Gold": "Oro 14k",
  "10k Gold": "Oro 10k",
  "Refine": "Refinar",
  "Browse": "Explorar",
  "Min": "Mín",
  "Max": "Máx",
  "Admin Console": "Consola de Administrador",
  "Access Console": "Acceder a la Consola",
  "Welcome to the M&A Jewelry console": "Bienvenido a la consola de M&A Jewelry",
  "This account does not have admin access.": "Esta cuenta no tiene acceso de administrador.",
  "View accessories": "Ver accesorios",
  "Search answers…": "Busca respuestas…",
  "No results found": "Sin resultados",
  "Try a different search term.": "Prueba con otro término de búsqueda.",
  "Clear all filters": "Borrar todos los filtros",
  "Filters": "Filtros",
  "Loading…": "Cargando…",
  "Featured": "Destacados",
  "Price: Low to High": "Precio: Menor a Mayor",
  "Price: High to Low": "Precio: Mayor a Menor",
  "Best Selling": "Más Vendidos",
  "Top Rated": "Mejor Valorados",
  "Alphabetical": "Alfabético",
  "Nothing found": "Sin resultados",
  "Try adjusting your filters or search.": "Intente ajustar sus filtros o búsqueda.",
  "Reset filters": "Restablecer filtros",
  "Search:": "Búsqueda:",

  // Product detail / card / quickview
  "In stock": "En existencia",
  "Currently sold out": "Agotado por ahora",
  "left — order soon": "restantes — pídelo pronto",
  "Only": "Solo",
  "Size": "Talla",
  "Add to Bag": "Añadir a la Bolsa",
  "Buy Now": "Comprar Ahora",
  "Sold Out": "Agotado",
  "New": "Nuevo",
  "Free Shipping": "Envío Gratis",
  "30-Day Returns": "Devoluciones 30 Días",
  "Specifications": "Especificaciones",
  "Shipping & Delivery": "Envío y Entrega",
  "Returns & Warranty": "Devoluciones y Garantía",
  "Complimentary insured shipping within the United States on every order. Standard delivery in 3–5 business days, with express options available. Every piece arrives in signature M&A Jewelry packaging with a certificate of authenticity.": "Envío asegurado y gratuito dentro de Estados Unidos en cada pedido. Entrega estándar en 3–5 días hábiles, con opción de envío exprés. Cada pieza llega en el empaque exclusivo de M&A Jewelry con certificado de autenticidad.",
  "Enjoy 30-day complimentary returns on unworn items in original condition. All M&A Jewelry pieces are covered by a lifetime warranty against manufacturing defects and includes free annual cleaning and inspection.": "Disfrute de devoluciones gratuitas de 30 días en artículos sin usar y en su estado original. Todas las piezas de M&A Jewelry cuentan con garantía de por vida contra defectos de fabricación e incluyen limpieza e inspección anual gratuita.",
  "Weight": "Peso",
  "Dimensions": "Dimensiones",
  "Available Finishes": "Acabados Disponibles",
  "You may also love": "También te puede encantar",
  "Piece not found": "Pieza no encontrada",
  "Back to shop": "Volver a la tienda",
  "View Full Details": "Ver Detalles Completos",
  "Added to wishlist": "Añadido a favoritos",
  "Removed from wishlist": "Eliminado de favoritos",
  "added to bag": "añadido a la bolsa",

  // Cart
  "Your bag is empty": "Tu bolsa está vacía",
  "Discover pieces crafted to be treasured.": "Descubre piezas creadas para atesorar.",
  "Explore the Collection": "Explorar la Colección",
  "Shopping Bag": "Bolsa de Compra",
  "Continue shopping": "Seguir comprando",
  "Order Summary": "Resumen del Pedido",
  "Coupon code": "Código de cupón",
  "Apply": "Aplicar",
  "Remove": "Quitar",
  "Shipping": "Envío",
  "Standard — Complimentary": "Estándar — Gratis",
  "Subtotal": "Subtotal",
  "Discount": "Descuento",
  "Free": "Gratis",
  "Estimated Tax": "Impuesto Estimado",
  "Total": "Total",
  "Proceed to Checkout": "Proceder al Pago",
  "for 10% off": "para 10% de descuento",
  "Try": "Prueba",

  // Checkout
  "Checkout": "Pago",
  "Return to shop": "Volver a la tienda",
  "Contact Information": "Información de Contacto",
  "Full Name": "Nombre Completo",
  "Email": "Correo",
  "Phone": "Teléfono",
  "Shipping Address": "Dirección de Envío",
  "Recipient Name": "Nombre del Destinatario",
  "Address Line 1": "Dirección Línea 1",
  "Address Line 2 (optional)": "Dirección Línea 2 (opcional)",
  "City": "Ciudad",
  "State / Region": "Estado / Región",
  "Postal Code": "Código Postal",
  "Country": "País",
  "Billing address same as shipping": "Dirección de facturación igual que envío",
  "Shipping Method": "Método de Envío",
  "Standard": "Estándar",
  "Express": "Exprés",
  "Overnight": "Nocturno",
  "3–5 business days": "3–5 días hábiles",
  "2 business days": "2 días hábiles",
  "Next business day": "Siguiente día hábil",
  "Payment": "Pago",
  "This is a demo checkout — no real payment is processed.": "Este es un pago de demostración — no se procesa ningún pago real.",
  "Credit / Debit Card": "Tarjeta de Crédito / Débito",
  "Name on Card": "Nombre en la Tarjeta",
  "Card Number": "Número de Tarjeta",
  "Expiry": "Vencimiento",
  "Your Order": "Tu Pedido",
  "Tax": "Impuesto",
  "Place Order": "Realizar Pedido",
  "Order placed successfully": "Pedido realizado con éxito",

  // Order confirmation
  "Order Confirmed": "Pedido Confirmado",
  "Thank you for your order": "Gracias por tu pedido",
  "A confirmation has been sent to": "Se ha enviado una confirmación a",
  "Order": "Pedido",
  "Status:": "Estado:",
  "We'll notify you when your order ships.": "Te avisaremos cuando tu pedido se envíe.",
  "View My Orders": "Ver Mis Pedidos",
  "Continue Shopping": "Seguir Comprando",
  "Order not found": "Pedido no encontrado",

  // Collections
  "Curated Worlds": "Mundos Curados",
  "The Collections": "Las Colecciones",
  "Each M&A Jewelry collection tells its own story — from the eternal solitaire to the boldest statement piece.": "Cada colección de M&A Jewelry cuenta su propia historia — desde el solitario eterno hasta la pieza más audaz.",
  "pieces — Explore": "piezas — Explorar",

  // About
  "Since 1908": "Desde 1908",
  "The art of enduring beauty": "El arte de la belleza perdurable",
  "Our Philosophy": "Nuestra Filosofía",
  "We craft jewelry not for a season, but for a lifetime.": "Creamos joyas no para una temporada, sino para toda la vida.",
  "M&A Jewelry was founded in a small atelier, with a singular belief: that jewelry should be an heirloom, carrying meaning far beyond its material worth. Over a century later, that belief still guides every design that leaves our workshop.": "M&A Jewelry nació en un pequeño taller, con una creencia singular: que la joyería debe ser una herencia, con un significado que va más allá de su valor material. Más de un siglo después, esa creencia sigue guiando cada diseño que sale de nuestro taller.",
  "Our Promise": "Nuestra Promesa",
  "What sets us apart": "Lo que nos distingue",
  "Rare Materials": "Materiales Raros",
  "Only the finest diamonds, gold and coloured stones, hand-selected by our gemologists.": "Solo los mejores diamantes, oro y piedras de color, seleccionados a mano por nuestros gemólogos.",
  "Master Craftsmanship": "Artesanía Maestra",
  "Each piece is sculpted by artisans with decades of experience at the bench.": "Cada pieza es esculpida por artesanos con décadas de experiencia en el taller.",
  "Responsibly Sourced": "Origen Responsable",
  "Conflict-free stones and recycled precious metals across every collection.": "Piedras libres de conflicto y metales preciosos reciclados en cada colección.",
  "Made to Last": "Hecho para Durar",
  "A lifetime warranty and complimentary care for jewelry meant for generations.": "Garantía de por vida y cuidado gratuito para joyas pensadas para generaciones.",
  "Begin your M&A Jewelry story": "Comienza tu historia con M&A Jewelry",
  "Discover pieces designed to be treasured, or book a private appointment with our concierge.": "Descubre piezas diseñadas para atesorar, o reserva una cita privada con nuestro concierge.",
  "Explore Jewelry": "Explorar Joyería",
  "Contact Us": "Contáctanos",

  // Contact
  "We're Here For You": "Estamos Aquí Para Ti",
  "Get in touch": "Ponte en contacto",
  "Flagship Boutique": "Boutique Insignia",
  "Call Us": "Llámanos",
  "Hours": "Horario",
  "Mon–Sat, 10:00 – 19:00 CET": "Lun–Sáb, 10:00 – 19:00 CET",
  "Private Appointments": "Citas Privadas",
  "Book a one-to-one consultation with our jewelry specialists, in-boutique or virtually.": "Reserva una consulta personalizada con nuestros especialistas en joyería, en la boutique o virtualmente.",
  "Send a message": "Envía un mensaje",
  "Name": "Nombre",
  "Subject": "Asunto",
  "Message": "Mensaje",
  "Send Message": "Enviar Mensaje",

  // Auth
  "Brilliance, worn for a lifetime.": "Brillo, para toda la vida.",
  "Maison de haute joaillerie · Chicago": "Maison de alta joyería · Chicago",
  "Welcome back": "Bienvenido de nuevo",
  "Sign in to your M&A Jewelry account": "Inicia sesión en tu cuenta M&A Jewelry",
  "New to M&A Jewelry?": "¿Nuevo en M&A Jewelry?",
  "Create an account": "Crear una cuenta",
  "Password": "Contraseña",
  "Forgot?": "¿Olvidó?",
  "Create your account": "Crea tu cuenta",
  "Join M&A Jewelry for private previews and faster checkout": "Únete a M&A Jewelry para adelantos privados y pagos más rápidos",
  "Already have an account?": "¿Ya tienes una cuenta?",
  "Sign in": "Iniciar sesión",
  "Password must be at least 6 characters": "La contraseña debe tener al menos 6 caracteres",
  "Reset password": "Restablecer contraseña",
  "We'll send you a secure link to reset your password": "Te enviaremos un enlace seguro para restablecer tu contraseña",
  "Back to sign in": "Volver a iniciar sesión",
  "Send Reset Link": "Enviar Enlace",
  "Set a new password": "Establece una nueva contraseña",
  "Choose a strong password for your account": "Elige una contraseña segura para tu cuenta",
  "New Password": "Nueva Contraseña",
  "Confirm Password": "Confirmar Contraseña",
  "Update Password": "Actualizar Contraseña",
  "Passwords do not match": "Las contraseñas no coinciden",

  // Account
  "Profile": "Perfil",
  "Wishlist": "Favoritos",
  "Addresses": "Direcciones",
  "Notifications": "Notificaciones",
  "Profile Settings": "Ajustes de Perfil",
  "Save Changes": "Guardar Cambios",
  "Order History": "Historial de Pedidos",
  "You haven't placed any orders yet.": "Aún no has realizado ningún pedido.",
  "Start Shopping": "Empezar a Comprar",
  "My Wishlist": "Mis Favoritos",
  "Your wishlist is empty.": "Tu lista de favoritos está vacía.",
  "Discover Jewelry": "Descubrir Joyería",
  "Add": "Añadir",
  "Saved Addresses": "Direcciones Guardadas",
  "New Address": "Nueva Dirección",
  "Set as default": "Establecer como predeterminada",
  "Save Address": "Guardar Dirección",
  "No saved addresses yet.": "Aún no hay direcciones guardadas.",
  "Added to bag": "Añadido a la bolsa",
  "Hello": "Hola",
  "Tracking:": "Seguimiento:",
  "Default": "Predeterminada",
  "Welcome to M&A Jewelry": "Bienvenido a M&A Jewelry",

  // WhatsApp
  "Chat on WhatsApp": "Escríbenos por WhatsApp",

  // Admin — layout & login
  "Admin Console": "Consola de Administración",
  "Dashboard": "Panel",
  "Products": "Productos",
  "Customers": "Clientes",
  "Discounts": "Descuentos",
  "Reports": "Reportes",
  "View Store": "Ver Tienda",
  "Welcome": "Bienvenido",
  "Access Console": "Acceder a la Consola",
  "This account does not have admin access.": "Esta cuenta no tiene acceso de administrador.",
  "Welcome to the M&A Jewelry console": "Bienvenido a la consola de M&A Jewelry",

  // Admin — dashboard
  "Overview of your store performance": "Resumen del rendimiento de tu tienda",
  "Total Revenue": "Ingresos Totales",
  "orders": "pedidos",
  "Orders Today": "Pedidos de Hoy",
  "New orders": "Pedidos nuevos",
  "Pending": "Pendientes",
  "Awaiting fulfilment": "Por procesar",
  "products live": "productos activos",
  "Revenue Trend": "Tendencia de Ingresos",
  "Order Status": "Estado de Pedidos",
  "No orders yet": "Aún no hay pedidos",
  "Best Selling Products": "Productos Más Vendidos",
  "No sales data yet": "Aún no hay datos de ventas",
  "Inventory Alerts": "Alertas de Inventario",
  "Recent Customers": "Clientes Recientes",
  "No customers yet": "Aún no hay clientes",

  // Admin — products
  "products in catalog": "productos en el catálogo",
  "Add Product": "Agregar Producto",
  "Search products or SKU": "Buscar productos o SKU",
  "Product": "Producto",
  "Stock": "Stock",
  "Flags": "Etiquetas",
  "Actions": "Acciones",
  "Edit Product": "Editar Producto",
  "New Product": "Nuevo Producto",
  "Description": "Descripción",
  "Price ($)": "Precio ($)",
  "Sale Price ($)": "Precio de Oferta ($)",
  "Barcode": "Código de Barras",
  "Primary Material": "Material Principal",
  "Materials (comma)": "Materiales (separados por coma)",
  "Finishes (comma)": "Acabados (separados por coma)",
  "Sizes (comma)": "Tallas (separadas por coma)",
  "Images": "Imágenes",
  "or add image by URL": "o agregar imagen por URL",
  "Best Seller": "Más Vendido",
  "New Arrival": "Novedad",
  "Active": "Activo",
  "Update Product": "Actualizar Producto",
  "Create Product": "Crear Producto",
  "Cancel": "Cancelar",
  "Delete this product?": "¿Eliminar este producto?",
  "This action cannot be undone.": "Esta acción no se puede deshacer.",
  "Delete": "Eliminar",
  "Image(s) uploaded": "Imagen(es) subida(s)",
  "Product updated": "Producto actualizado",
  "Product created": "Producto creado",
  "Product deleted": "Producto eliminado",
  "Paste image URL": "Pega la URL de la imagen",

  // Admin — orders
  "total orders": "pedidos en total",
  "Search order # or customer": "Buscar pedido # o cliente",
  "All Statuses": "Todos los Estados",
  "No orders found": "No se encontraron pedidos",
  "Customer": "Cliente",
  "Date": "Fecha",
  "Status": "Estado",
  "Tracking Number": "Número de Seguimiento",
  "Add tracking #": "Agregar # de seguimiento",
  "Print Invoice": "Imprimir Factura",
  "Order updated": "Pedido actualizado",
  "Qty": "Cant.",
  "pending": "pendiente",
  "processing": "procesando",
  "shipped": "enviado",
  "delivered": "entregado",
  "cancelled": "cancelado",
  "refunded": "reembolsado",
  "Invoice": "Factura",
  "Ship to:": "Enviar a:",
  "Item": "Artículo",
  "Thank you for your order · M&A Jewelry": "Gracias por tu pedido · M&A Jewelry",

  // Admin — customers
  "registered customers": "clientes registrados",
  "Search customers": "Buscar clientes",
  "Joined": "Registrado",
  "Total Spent": "Total Gastado",
  "No customers found": "No se encontraron clientes",
  "Purchase History": "Historial de Compras",

  // Admin — coupons
  "active coupon codes": "códigos de cupón activos",
  "New Coupon": "Nuevo Cupón",
  "Create Coupon": "Crear Cupón",
  "Code": "Código",
  "Type": "Tipo",
  "Percentage %": "Porcentaje %",
  "Fixed $": "Fijo $",
  "Value": "Valor",
  "Min Order ($)": "Pedido Mínimo ($)",
  "Expires": "Vence",
  "off": "de descuento",
  "Min:": "Mín:",
  "None": "Ninguno",
  "No expiry": "Sin vencimiento",
  "Coupon created": "Cupón creado",
  "Coupon deleted": "Cupón eliminado",

  // Admin — reports
  "Sales, revenue & inventory analytics": "Análisis de ventas, ingresos e inventario",
  "Revenue": "Ingresos",
  "Avg Order Value": "Valor Promedio de Pedido",
  "Inventory Value": "Valor de Inventario",
  "Top Products by Revenue": "Productos con Más Ingresos",
  "Revenue by Category": "Ingresos por Categoría",
  "Product Sales Detail": "Detalle de Ventas por Producto",
  "No sales recorded yet.": "Aún no se registran ventas.",
  "Units Sold": "Unidades Vendidas",
  "Units": "Unidades",
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem(KEY) || "en");

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === "en" ? "es" : "en"));
  const t = (s) => (lang === "es" ? (ES[s] ?? s) : s);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
